import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import SidebarPageLayout from '../../components/layout/SidebarPageLayout';

function Documentation() {

  useEffect(() => {
    document.title = "Vivosol Plant Performance Insights Hub | Help / Documentation";
  }, []);

  return (
    <SidebarPageLayout id="documentation">
      <div className="content p-5">
        <h2>Documentation</h2>
        <ul className="list-unstyled mt-4">
          <li>
            <Link to="/help/documentation/fault-codes">Fault Codes</Link>
          </li>
          <li>
            <Link to="/help/documentation/roles">Roles</Link>
          </li>
          <li>
            <Link to="/help/documentation/site-types">Site Types</Link>
          </li>
        </ul>
      </div>
    </SidebarPageLayout>
  );
}

export default Documentation;
